import React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { images } from "../../Images/Svg";
import CommonButton from "../../CommonComponents/CommonButton";
import { useEffect } from "react";

const { deleteIcon } = images;

export const vendorDraftTableData = {
  row: [
    {
      file_Name: "ABCD Pvt. Ltd.",
      saved_On: "07/09/2023",
      action: "Continue",
      delete: deleteIcon,
    },
    {
      file_Name: "ABCD Pvt. Ltd.",
      saved_On: "07/09/2023",
      action: "Continue",
      delete: deleteIcon,
    },
    {
      file_Name: "ABCD Pvt. Ltd.",
      saved_On: "07/09/2023",
      action: "Continue",
      delete: deleteIcon,
    },
  ],
  column: [
    {
      id: "file_Name",
      label: "File Name",
      align: "left",
    },
    {
      id: "saved_On",
      label: "Saved On",
      align: "left",
    },
    {
      id: "action",
      label: "Action",
      align: "left",
    },
    {
      id: "delete",
      label: "Delete",
      align: "right",
    },
  ],
};

const VendorDraft = () => {
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      fontSize: "1.1rem",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: "1.1rem",
      border: 0,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:not(:last-child) td": {
      borderBottom: "1px solid #CCC",
    },
  }));

  useEffect(() => {
    window?.scroll(0, 0);
  }, []);

  return (
    <TableContainer
      sx={{
        overflowX: "unset",
        boxShadow: "0px 5px 25px rgba(0, 0, 0, 0.06)",
        border: "1px solid #CCC",
        minHeight: "60vh",
        borderRadius: "1rem",
      }}
    >
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            {vendorDraftTableData?.column?.map((item, index) => (
              <StyledTableCell
                key={item?.id}
                align={item?.align}
                sx={{
                  backgroundColor: "#D9ECFF",
                  borderRadius:
                    index === 0
                      ? "1rem 0 0"
                      : index === vendorDraftTableData?.column?.length - 1
                      ? "0 1rem 0 0"
                      : "unset",
                }}
              >
                {item?.label}
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {vendorDraftTableData?.row?.map((item) => (
            <StyledTableRow key={item?.id}>
              {vendorDraftTableData?.column?.map((col) => (
                <StyledTableCell component="td" scope="row" align={col?.align}>
                  {col?.id === "delete" ? (
                    <img
                      style={{ cursor: "pointer" }}
                      src={item?.[col?.id]}
                      alt="delete"
                    />
                  ) : col?.id === "action" ? (
                    <CommonButton
                      fitContent
                      label={item?.[col?.id]}
                      isColor
                      backgroundColor={"#E42125"}
                      textColor={"white"}
                      sx={{ padding: "0 1.5rem", fontSize: "1rem" }}
                      borderRadius="10px"
                      isHover
                      hoverColor={"#E42125"}
                      boxShadow={"0px 4px 10px 0px rgba(0, 0, 0, 0.25)"}
                    />
                  ) : (
                    item?.[col?.id]
                  )}
                </StyledTableCell>
              ))}
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default VendorDraft;
